import styled from "styled-components";

export const HomeContainer = styled.div`
  background-color: #E8E5E5;
  width: 100%;
  min-height: 100vh;
  height: fit-content;
  display: flex;
  flex-direction: column;
  `;

export const HomeContent = styled.div`
  flex: 1
`;

export const SocialMedia = styled.div`
  display: flex;
  padding: 20px;
`;

export const InstagramLink = styled.div`
  display: flex;
  align-items: center;
  width: 250px;
  /* min-width: 35%; */
  max-width: 250px;
  height: 30px;
  padding: 15px;
  border-radius: 8px;
  background: linear-gradient(135deg, #D3337F, #833AB4);
  margin-right: 10px;
  cursor: pointer;
  filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.8));
  /* box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1), 0px 1px 3px rgba(0, 0, 0, 0.06); */
`;

export const WhatsAppLink = styled.div`
  display: flex;
  align-items: center;
  width: 250px;
  /* min-width: 35%; */
  max-width: 250px;
  height: 30px;
  padding: 15px;
  border-radius: 8px;
  background: linear-gradient(135deg, #2FB943, #128C7E); 
  cursor: pointer;
  filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.8));
  /* box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1), 0px 1px 3px rgba(0, 0, 0, 0.06); */
`;

export const SocialMediaIcon = styled.img`
  width: 18px;
  margin-right: 5px;
`;

export const SocialMediaInformation = styled.span`
  color: #fafbfc;
  font-size: 14px;
`;

export const SelectCategories = styled.select`
  width: 250px;
  min-width: 35%;
  height: 30px;
  border-radius: 8px;
  background-color: #FAFBFC;
  color: #333;
  /* box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1), 0px 1px 3px rgba(0, 0, 0, 0.06); */
  filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.4));
  padding: 0px 10px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  position: relative;
  
  padding-right: 30px;
 
  font-size: 16px;
  cursor: pointer;

  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='black'%3E%3Cpath fill-rule='evenodd' d='M10 15a.75.75 0 01-.53-.22l-5-5a.75.75 0 011.06-1.06L10 13.19l4.47-4.47a.75.75 0 011.06 1.06l-5 5A.75.75 0 0110 15z' clip-rule='evenodd'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: calc(100% - 10px) center;
  background-size: 16px;
  margin: 0px 0px 20px 20px;
`;

export const PizzaSection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const PizzaSectionTitle = styled.span`
  margin-left: 20px;
  font-weight: bold;
  color: #333;
  font-size: 16px;
`;

export const CardRefrigerator = styled.div`
  display: flex;
  position: relative;
	flex-direction: column;
	margin: 20px;
	width: 92%;
	border-radius: 8px;
	background-color: #FAFBFC;
	height: 170px;
	padding: 20px;
	box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1), 0px 1px 3px rgba(0, 0, 0, 0.06);
	cursor: pointer;

  @media screen and (min-width: 1000px) {
		width: 98%;
	}

	@media screen and (min-width: 750px) {
		width: 97%;
	}

	@media screen and (max-width: 426px) {
		display: flex;
		width: 90%;
	}
`;

export const CardPrice = styled.div`
  position: absolute;
	margin-bottom: 10px;
	height: 30px;
	background-color: #9B2424;
	color: #fafbfc;
	display: flex;
	align-items: center;
	padding: 0px 10px;
	border-radius: 4px;
	bottom: 10px;
	left: 50%;
	transform: translateX(-50%);
`;

export const CardImage = styled.img`
  width: 100px;
  height: 100px;

  filter: drop-shadow(-4px 4px 2px rgba(0, 0, 0, 0.8));
`;

export const ButtonGroup = styled.div`
	position: absolute;
	bottom: 5px;
	right: 5px;
	display: flex;
	align-items: center;
	border: none;
	margin-top: 10px;
`;

export const CurrentRefriQtd = styled.span`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 30px;
	height: 30px;
	font-size: 14px;
	background-color: #f5f5f5;
	border: 1px solid #ccc;
`;

export const Button = styled.button`
  height: 30px;
  width: 30px;
	border: none;
  border-radius: 0px 4px 4px 0px;

  &:first-child {
    border-radius: 4px 0px 0px 4px;
  }

	/* background-color: ${(props) => (props.action === "add" ? "#79A92E" : "#79A92E")}; */
  background: linear-gradient(135deg,rgb(67, 112, 176), #0053BA);
	color: white;
	cursor: pointer;
	font-size: 14px;

	&:hover {
		opacity: 0.9;
	}
`;